import {authAxios} from './../../config/axios';

class Infinity{	
	get=(params=[])=>{
		return authAxios.get(`/plan/infinity/plans`,{
			params
		});
	}

	show=(id)=>{
		return authAxios.get(`/plan/infinity/plans/${id}`)
	}

	update=(id,data)=>{
		return authAxios.put(`/plan/infinity/plans/${id}`,data)
	}

	save=(data)=>{
		let formData = new FormData();

		for(let k in data)
			formData.append(k,data[k]);

		return authAxios.post(`/plan/infinity/plans/save`,formData);
	}

	updateImage=(id,image)=>{
		let formData = new FormData();
		formData.append('image',image);
		return authAxios.post(`/plan/infinity/plans/${id}/image`,formData);
	}
}

export default (new Infinity());
